import featuredimg1 from '../../assets/Images/property/featuredimg1.webp'
import featuredimg3 from '../../assets/Images/property/featuredimg3.jpg'
import featuredimg2 from '../../assets/Images/property/featuredimg2.jpg'
import sale4 from '../../assets/Images/property/sale4.png'
import sale5 from '../../assets/Images/property/sale5.png'
import sale6 from '../../assets/Images/property/sale6.png'
import sale7 from '../../assets/Images/property/sale7.png'
import sale8 from '../../assets/Images/property/sale8.png'
import sale9 from '../../assets/Images/property/sale9.png'


export const rent = [
    {
        image:featuredimg2,
        price:"6,250",
        title:"Bunglow for rent",
        address:"Leeds city center",
        bed:"4",
        bath:"4",
        furniture:"furnished",
       
    },
    {
        image:featuredimg3,
        price:"850",
        title:"Penthouse",
        address:"Menchester city",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
      
    },
    {
        image:featuredimg1,
        price:"6,25",
        title:"Bunglow",
        address:"Leeds city center",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale4,
        price:"345",
        title:"Bunglow",
        address:"Derby side country ",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale5,
        price:"645",
        title:"semi detached house",
        address:"Southfield Road, Oxford OX4",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale6,
        price:"200",
        title:"penthouse",
        address:"Menchester city",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale7,
        price:"240",
        title:"Bunglow",
        address:"Leeds city center",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale8,
        price:"125",
        title:"penthouse ",
        address:"Menchester city",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
    {
        image:sale9,
        price:"200",
        
        title:"Semi detached house",
        address:"Southfield Road, Oxford OX4",
        bed:"3",
        bath:"2",
        furniture:"semi-furnished",
    },
   
   
   
   
   

]